var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": (_vm.openedUser ? '编辑' : '邀请') + '员工'
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "名字",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入名字..."
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "手机号",
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入手机号..."
    },
    model: {
      value: _vm.formItem.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "mobile", $$v);
      },
      expression: "formItem.mobile"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "企业微信号",
      "prop": "weworkUserId"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入企业微信号..."
    },
    model: {
      value: _vm.formItem.weworkUserId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "weworkUserId", $$v);
      },
      expression: "formItem.weworkUserId"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "超级管理员",
      "prop": "superAdmin"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: _vm.formItem.superAdmin,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "superAdmin", $$v);
      },
      expression: "formItem.superAdmin"
    }
  }, [_vm._v("超级管理员")])], 1), !_vm.formItem.superAdmin ? _c('FormItem', {
    attrs: {
      "label": "职位",
      "prop": "simpleRole"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "placeholder": "选择职位"
    },
    on: {
      "on-change": _vm.selectSimpleRole
    },
    model: {
      value: _vm.formItem.simpleRole,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "simpleRole", $$v);
      },
      expression: "formItem.simpleRole"
    }
  }, _vm._l(_vm.roleList, function (role) {
    return _c('Option', {
      key: role.value,
      attrs: {
        "value": role.value
      }
    }, [_vm._v(_vm._s(role.name))]);
  }), 1)], 1) : _vm._e(), !_vm.formItem.superAdmin && _vm.arrayIntersection(['acctManager', 'acct'], _vm.formItem.simpleRole).length > 0 ? _c('FormItem', {
    attrs: {
      "label": "财务可见公司",
      "prop": "simpleRole"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.acctVisibleCompany,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "acctVisibleCompany", $$v);
      },
      expression: "formItem.acctVisibleCompany"
    }
  }, _vm._l(_vm.companyList, function (company) {
    return _c('Option', {
      key: company._id,
      attrs: {
        "value": company._id
      }
    }, [_vm._v(_vm._s(company.name))]);
  }), 1)], 1) : _vm._e(), !_vm.formItem.superAdmin && _vm.arrayIntersection(['salesAssist'], _vm.formItem.simpleRole).length > 0 ? _c('FormItem', {
    attrs: {
      "label": "销售项目成本可见公司",
      "prop": "simpleRole"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.salesCalcCostVisibleCompany,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "salesCalcCostVisibleCompany", $$v);
      },
      expression: "formItem.salesCalcCostVisibleCompany"
    }
  }, _vm._l(_vm.companyList, function (company) {
    return _c('Option', {
      key: company._id,
      attrs: {
        "value": company._id
      }
    }, [_vm._v(_vm._s(company.name))]);
  }), 1)], 1) : _vm._e(), !_vm.formItem.superAdmin && _vm.arrayIntersection(['purchase', 'purchaseLead'], _vm.formItem.simpleRole).length > 0 ? _c('FormItem', {
    attrs: {
      "label": "采购可见工厂",
      "prop": "simpleRole"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.purchaseVisibleFactory,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "purchaseVisibleFactory", $$v);
      },
      expression: "formItem.purchaseVisibleFactory"
    }
  }, _vm._l(_vm.factoryList, function (factory) {
    return _c('Option', {
      key: factory._id,
      attrs: {
        "value": factory._id
      }
    }, [_vm._v(_vm._s(factory.name))]);
  }), 1)], 1) : _vm._e(), !_vm.formItem.superAdmin && _vm.arrayIntersection(['productionWorkers', 'deliveryAssist', 'factoryLeader'], _vm.formItem.simpleRole).length > 0 ? _c('FormItem', {
    attrs: {
      "label": "销售订单可见工厂",
      "prop": "simpleRole"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.factoryRole,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "factoryRole", $$v);
      },
      expression: "formItem.factoryRole"
    }
  }, _vm._l(_vm.factoryList, function (factory) {
    return _c('Option', {
      key: factory._id,
      attrs: {
        "value": factory._id
      }
    }, [_vm._v(_vm._s(factory.name))]);
  }), 1)], 1) : _vm._e(), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("创建")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }